export const ROLE_NAME_PREFIX = "ROLE_";

export const stripRoleNamePrefix = (value = "") => {
  const trimmedValue = value.trim();

  return trimmedValue.startsWith(ROLE_NAME_PREFIX)
    ? trimmedValue.slice(ROLE_NAME_PREFIX.length)
    : trimmedValue;
};

export const withRoleNamePrefix = (value = "") => {
  return ROLE_NAME_PREFIX + stripRoleNamePrefix(value);
};
